import { render, staticRenderFns } from "./MealRecipes.vue?vue&type=template&id=5449f9e8&scoped=true&"
import script from "./MealRecipes.vue?vue&type=script&lang=js&"
export * from "./MealRecipes.vue?vue&type=script&lang=js&"
import style0 from "./MealRecipes.vue?vue&type=style&index=0&id=5449f9e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449f9e8",
  null
  
)

export default component.exports